import { shareByEmail as shareByEmail_1 } from './getShareByEmailButton.locstring.json';
import loc from 'owa-localize';
import logSxSCommandBarDatapoint from './logSxSCommandBarDatapoint';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { ControlIcons } from 'owa-control-icons';
import { shareByEmail } from 'owa-attachment-sharebyemail';
import { createAttachmentFileFromAttachmentData } from 'owa-fileshub-store/lib/utils/createAttachmentFileFromAttachmentData';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { getOrCreateSxSStoreData } from 'owa-sxs-store';
import { ComposeTarget } from 'owa-mail-compose-store';

export default function getShareByEmailButton(sxsId: string) {
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    const attachmentId = sxsStore.extendedViewState.attachmentId;
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(shareByEmail_1),
        [FilterableMenuItemArgs.icon]: ControlIcons.Mail,
        [FilterableMenuItemArgs.onClick]: async () => {
            const attachmentFile = await createAttachmentFileFromAttachmentData(attachmentId);
            shareByEmail([attachmentFile], ComposeTarget.Popout);
            logSxSCommandBarDatapoint('SxSShareByEmail', sxsId);
        },
        [FilterableMenuItemArgs.shouldShow]: () => {
            return attachmentId != null && getAttachment(attachmentId) != null;
        },
    });
}
